import { Flex, Transition } from '@mantine/core';

import { BannerType } from 'models';

import { CONTENT_WIDTH } from 'components/page/Content';
import { useBannerMessage } from 'hooks/use-banner-message';

export const FooterBannerMessage = () => {
    const { BannerContent, showBanner } = useBannerMessage(BannerType.Footer);

    return (
        <Transition mounted={showBanner} transition="slide-up">
            {(styles) => (
                <Flex
                    data-announcement-banner
                    pos="fixed"
                    left="50%"
                    maw="calc(100% - var(--mantine-spacing-md) * 2)"
                    w={CONTENT_WIDTH}
                    bdrs="md"
                    style={{
                        boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
                        zIndex: 1000,
                        bottom: 'var(--mantine-spacing-md)',
                        ...styles,
                        transform: `${styles.transform || ''} translateX(-50%)`,
                    }}
                    py="sm"
                    px="md"
                    justify="space-between"
                    align="center"
                    className="gradient-cyan-green-background-light"
                >
                    {BannerContent}
                </Flex>
            )}
        </Transition>
    );
};
